import { inject, Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslocoService } from "@jsverse/transloco";
import { Subject } from "rxjs";

@Injectable()
export class PaginatorIntl implements MatPaginatorIntl {
  translocoService = inject(TranslocoService);

  changes = new Subject<void>();

  firstPageLabel = this.translocoService.translate(`paginator.first-page`);
  itemsPerPageLabel =
    this.translocoService.translate(`paginator.items-per-page`) + ":";
  lastPageLabel = this.translocoService.translate(`paginator.last-page`);
  nextPageLabel = this.translocoService.translate("paginator.next-page");
  previousPageLabel = this.translocoService.translate(
    "paginator.previous-page"
  );

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this.translocoService.translate("paginator.0-page-of", {
        length
      });
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return this.translocoService.translate("paginator.page-of", {
      startIndex: startIndex + 1,
      endIndex,
      length
    });
  }
}
